// P2b tanda 6 (PARTE C) — la píldora "N/M" con barra de la columna Ficha (tabla
// y mosaico). SOLO LEE la evaluación materializada: un producto sin doc muestra
// "—" con su motivo, nunca un número inventado. El tooltip dice CUÁLES faltan.
import React from 'react';
import { NOMBRES } from '../utils/fichaEstado';
import './FichaBarra.css';

export default function FichaBarra({ ficha, compacta = false }) {
  if (!ficha || !ficha.aplicables) {
    return <span className="fb-vacia" title="Se calcula en la próxima sincronización">—</span>;
  }
  const pct = Math.round((ficha.cumplidas / ficha.aplicables) * 100);
  const pendientes = (ficha.pendientesIds || []).map((id) => NOMBRES[id] || id).join(' · ');
  const titulo = pendientes ? `Pendientes: ${pendientes}` : 'Ficha completa';
  return (
    <span className={`fb${compacta ? ' fb--compacta' : ''}`} title={titulo} data-testid="ficha-barra">
      {/* Tanda 7c (punto 5): el número viaja TAMBIÉN en la tarjeta del Mosaico
          (compacta = barra más corta y tipografía menor, no menos información). */}
      <span className="fb-num">{ficha.cumplidas}/{ficha.aplicables}</span>
      <span className="fb-barra"><span className="fb-relleno" style={{ width: `${pct}%` }} /></span>
    </span>
  );
}
